export default "__VITE_ASSET__DVDIuFCU__"